import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";

import PageSpinner from "../../../components/elements/pageSpinner";
import { useCompanyQuery } from "../../../graphql/graphql";
import { getRoutePath } from "../../../router";
import Presenter from "./presenter";

interface CompanyPhoneChangePageProps {}

const CompanyPhoneChangePage: React.FC<CompanyPhoneChangePageProps> = () => {
  const { data: currentCompanyData } = useCompanyQuery();
  const navigate = useNavigate();
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });
  const onDrawerClose = () => {
    onClose();
    setTimeout(() => {
      navigate(getRoutePath("companySettings"));
    }, 500);
  };

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onDrawerClose}>
      <DrawerOverlay>
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Company Phone</DrawerHeader>
          <DrawerBody>
            <Box marginTop="10">
              {currentCompanyData ? (
                <Presenter currentCompany={currentCompanyData.company} />
              ) : (
                <PageSpinner />
              )}
            </Box>
          </DrawerBody>
        </DrawerContent>
      </DrawerOverlay>
    </Drawer>
  );
};

export default CompanyPhoneChangePage;
